import * as actions from '../actions/advancedDisbursements';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import {getArrayPamaterer} from "../helpers/functions";

export function requestGetStatementMessages(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/StatementMessages',
            category: 'requestGetStatementMessages',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetStatementMessages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getAdvanceDisbursementsStatementMessagesSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestGetStatementMessagesFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetStatementMessages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getAdvanceDisbursementsStatementMessagesFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestGetAdvanceDisbursementsDueForPayment(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/disbursements?limit=0&offset=0&statusIds='
                + action.payload.paidAdStatusId
                + `&lawsysIds=${action.payload.lawsysId}`,
            category: 'requestGetAdvanceDisbursementsDueForPayment',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetAdvanceDisbursementsDueForPayment')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getAdvanceDisbursementsDueForPaymentSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestGetAdvanceDisbursementsDueForPaymentFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetAdvanceDisbursementsDueForPayment')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getAdvanceDisbursementsDueForPaymentFailed(response));

    return {
        ACTION: httpResponse$
    };
}


export function requestApplicationAdUpdateStatus(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_APPLICATION_AD_UPDATE_STATUS)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/application/' + action.payload + '/update',
            category: 'requestApplicationAdUpdateStatus',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestApplicationAdUpdateStatus')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getApplicationAdUpdateStatusSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestApplicationAdUpdateStatusFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestApplicationAdUpdateStatus')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getApplicationAdUpdateStatusFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestAdvanceDisbursementsStatuses(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ADVANCE_DISBURSEMENTS_STATUSES)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/statuses',
            category: 'requestAdvanceDisbursementsStatuses',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestAdvanceDisbursementsStatuses')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivedAdvancedDisbursementsStatuses(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestAdvanceDisbursementsStatuses(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestAdvanceDisbursementsStatuses')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveAdvanceDisbursementsStatuses(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestAdvanceDisbursementsRejectionReasons(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ADVANCE_DISBURSEMENTS_REJECTION_REASONS)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/rejectionReasons',
            category: 'requestAdvanceDisbursementsRejectionReasons',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestAdvanceDisbursementsRejectionReasons')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivedAdvanceDisbursementsRejectionReasons(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestAdvanceDisbursementsRejectionReasons(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestAdvanceDisbursementsRejectionReasons')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveAdvanceDisbursementsRejectionReasons(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestEditAdvanceDisbursementById(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.EDIT_ADVANCE_DISBURSEMENT)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/disbursements/' + action.payload.id,
            category: 'requestEditAdvanceDisbursementById',
            method: 'PATCH',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestEditAdvanceDisbursementById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveEditAdvanceDisbursement(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestEditAdvanceDisbursementById(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestEditAdvanceDisbursementById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToEditAdvanceDisbursement(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestAdvanceDisbursementById(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ADVANCE_DISBURSEMENT_BY_ID)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/disbursements/' + action.payload,
            category: 'requestAdvanceDisbursementById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestAdvanceDisbursementById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveAdvanceDisbursementById(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestAdvanceDisbursementById(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestAdvanceDisbursementById')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveAdvanceDisbursementById(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestAllAdvanceDisbursementsSuggestions(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/disbursements?limit=' +
                action.payload.limit +
                '&offset=' + action.payload.offset +
                '&search=' + action.payload.search +
                (action.payload.paymentInstructionId !== null ?('&PaymentInstructionId=' + action.payload.paymentInstructionId): '') +
                (getArrayPamaterer(action.payload.selectedFirms, 'lawsysIds')?
                    `&${getArrayPamaterer(action.payload.selectedFirms, 'lawsysIds')}`:'') +
                (getArrayPamaterer(action.payload.selectedStatuses, 'statusIds')?
                    `&${getArrayPamaterer(action.payload.selectedStatuses, 'statusIds')}`:'') +
                (getArrayPamaterer(action.payload.selectedCaseTypes, 'caseTypesIds')?
                    `&${getArrayPamaterer(action.payload.selectedCaseTypes, 'caseTypesIds')}`:'') +
                (getArrayPamaterer(action.payload.selectedSubCaseTypes, 'subCaseTypesIds')?
                    `&${getArrayPamaterer(action.payload.selectedSubCaseTypes, 'subCaseTypesIds')}`:'') ,
            category: 'requestAllAdvanceDisbursementsSuggestions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestAllAdvanceDisbursementsSuggestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveAllAdvancedDisbursementsSuggestions(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestAllAdvanceDisbursementsSuggestions(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestAllAdvanceDisbursementsSuggestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveAdvancedDisbursementsSuggestions(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestAllAdvancedDisbursements(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ALL_ADVANCED_DISBURSEMENTS)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/disbursements?limit=' +
                action.payload.limit +
                '&offset=' + action.payload.offset +
                (action.payload.paymentInstructionId !== null ?('&PaymentInstructionId=' + action.payload.paymentInstructionId): '') +
                (action.payload.minAmount && (action.payload.minAmount !== 0)?('&minAmount=' + action.payload.minAmount): '') +
                (action.payload.maxAmount && (action.payload.maxAmount !== 0)?('&maxAmount=' + action.payload.maxAmount): '') +
                (action.payload.search?('&search=' + action.payload.search): '') +
                (getArrayPamaterer(action.payload.selectedFirms, 'lawsysIds')?
                    `&${getArrayPamaterer(action.payload.selectedFirms, 'lawsysIds')}`:'') +
                (getArrayPamaterer(action.payload.selectedStatuses, 'statusIds')?
                    `&${getArrayPamaterer(action.payload.selectedStatuses, 'statusIds')}`:'') +
                (getArrayPamaterer(action.payload.selectedCaseTypes, 'caseTypesIds')?
                    `&${getArrayPamaterer(action.payload.selectedCaseTypes, 'caseTypesIds')}`:'') +
                (getArrayPamaterer(action.payload.selectedSubCaseTypes, 'subCaseTypesIds')?
                    `&${getArrayPamaterer(action.payload.selectedSubCaseTypes, 'subCaseTypesIds')}`:'') ,
            category: 'requestAllAdvancedDisbursements',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestAllAdvancedDisbursements')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveAllAdvancedDisbursements(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestAllAdvancedDisbursements(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestAllAdvancedDisbursements')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveALlAdvancedDisbursements(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestAdvancedDisbursementsOfAPolicy(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ADVANCED_DISBURSEMENTS_OF_A_POLICY)
        .map(action => ({
            url: BASE_URL + 'api/Applications/Disbursements/' + action.payload,
            category: 'requestAdvancedDisbursementsOfAPolicy',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestAdvancedDisbursementsOfAPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveAdvancedDisbursementsOfAPolicy(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorRequestAdvancedDisbursementsOfAPolicy(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestAdvancedDisbursementsOfAPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveAdvancedDisbursementsOfAPolicy(response));

    return {
        ACTION: httpResponse$
    };
}

export function postAdvancedDisbursement(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.CREATE_ADVANCED_DISBURSEMENT)
        .map(action => ({
            url: BASE_URL + 'api/AdvanceDisbursements/disbursements',
            category: 'postAdvancedDisbursement',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('postAdvancedDisbursement')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.receiveCreateAdvancedDisbursement(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function errorPostingAdvancedDisbursement(sources) {
    let httpResponse$ = sources.HTTP
        .select('postAdvancedDisbursement')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 201)
        .map(response => actions.failedToCreateAdvancedDisbursement(response));

    return {
        ACTION: httpResponse$
    };
}
